import moment from 'moment';
import React from 'react';
import { withRouter } from 'react-router';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import styled from 'styled-components';
import Anchor from 'components/Anchor';
import { DateCard } from 'components/DateCard';
import { EventYearFilter } from 'components/Events';
import { useGetEventsAdmin } from 'components/Events/gql';
import Icon from 'components/Icon';
import MobileContainer from 'components/MobileContainer';
import Spacer from 'components/Spacer';
import Text from 'components/Text';
import { TransactionDateFilter } from 'components/Transactions/TransactionDateFilter';
import { TrackName } from 'components/UpcomingEvents';
import { CardHeader } from 'pages/employee/Events/EventsList';

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

const CardInfo = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const EventsList = () => {
  const { pathname } = useLocation();
  const eventType = pathname.includes('track')
    ? 'track'
    : pathname.includes('admin/events')
    ? 'events'
    : 'series';
  const { data } = useGetEventsAdmin(eventType);

  const { id } = useParams();

  const events = data?.getEventsAdmin?.results ?? [];

  if (!data?.getEventsAdmin) return false;

  return (
    <>
      <EventYearFilter />
      {eventType === 'events' && (
        <div style={{ padding: '0 18px' }}>
          <TransactionDateFilter maxWidth="300px" minWidth="190px" />
        </div>
      )}

      {events.map((item, index) => (
        <Anchor
          to={
            eventType !== 'events'
              ? `/admin/${eventType}/${id}/events/${
                  item.id
                }/participants?date=${moment(
                  item.start_date,
                  'MM-DD-YYYY'
                ).format('YYYY-MM-DD')}`
              : {
                  pathname: `/admin/events/menu/${item.id}`,
                  state: { event: item },
                }
          }
          key={index}
        >
          <MobileContainer>
            <FlexRow>
              <CardInfo>
                <CardHeader>
                  <div>
                    <TrackName>{item.track.name}</TrackName>
                  </div>
                </CardHeader>
                {'postponed' === item.status ? (
                  <img
                    style={{
                      width: '25%',
                      height: 'auto',
                      display: 'block',
                      transform: 'rotate(10deg)',
                    }}
                    src="https://d3294qt0f4hbwl.cloudfront.net/postponed.png"
                    alt="postponed-stamp"
                  />
                ) : null}
                {'cancelled' === item.status ? (
                  <img
                    style={{
                      width: '25%',
                      height: 'auto',
                      display: 'block',
                      transform: 'rotate(10deg)',
                    }}
                    src="https://d3294qt0f4hbwl.cloudfront.net/cancelled.png"
                    alt="cancelled-stamp"
                  />
                ) : null}

                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ width: 100 }}>
                    <DateCard item={item} />
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <Text
                        type="heading"
                        fontSize={25}
                        lineHeight={28}
                        color="#fff"
                      >
                        {item.name}
                      </Text>
                      <Spacer size={10} />
                    </div>
                  </div>
                </div>
              </CardInfo>
              <div style={{ transform: 'rotate(-90deg)' }}>
                <Icon icon="chevron" size={22} color={'#fa4616'} />
              </div>
            </FlexRow>
          </MobileContainer>
        </Anchor>
      ))}
    </>
  );
};

export default withRouter(EventsList);
